// Generated by scripts/generate-app-version.mjs.
export const APP_RELEASE = {
  "version": "1.0.0",
  "buildId": "20261104T191327069Z",
  "builtAt": "2026-11-04T19:13:27.069Z"
} as const;
